import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import reportWebVitals from "./reportWebVitals";
import axios from "axios";
import { LoaderProvider } from "./context/LoaderContext";

// Global axios interceptor to handle expired tokens
axios.interceptors.response.use(
  (response) => {
    return response;
  },
  (error) => {
    if (error.response) {
      // Handle 401 (Unauthorized) and 403 (Forbidden) responses
      if (error.response.status === 401 || error.response.status === 403) {
        // Clear localStorage
        localStorage.clear();

        // Redirect to login page
        window.location.href = "/login";

        // Show toast message if available
        if (window.ToastMessgae) {
          window.ToastMessgae({
            message: "Session expired. Please login again.",
          });
        }
      }
    }
    return Promise.reject(error);
  }
);

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <LoaderProvider>
      <App />
    </LoaderProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
